<template>
  <div v-if="!isLandscape && showHeroList.length" class="hero-section">
    <!-- 少于 4 个：居中静态排布，不轮播 -->
    <div v-if="!needHeroSwiper" class="hero-section-centered">
      <div
        v-for="(item, index) in showHeroList"
        :key="item.enname || index"
        class="hero-section-item"
        @click="jumpLink(item.basic.redirectLink)"
      >
        <div class="hero-section-img-wrap">
          <img
            :src="item.basic.cover"
            class="hero-section-img"
            :alt="item.basic.title || 'hero'"
          />
        </div>
        <p class="hero-section-title">{{ item.basic.title }}</p>
      </div>
    </div>
    <!-- 大于等于 4 个：横向轮播 -->
    <template v-else>
      <div ref="heroSwiperEl" class="hero-section-swiper swiper-container">
        <div class="swiper-wrapper hero-section-wrap">
          <div
            class="swiper-slide hero-section-item"
            v-for="(item, index) in showHeroList"
            :key="item.enname || index"
            @click="jumpLink(item.basic.redirectLink)"
          >
            <div class="hero-section-img-wrap">
              <img
                :src="item.basic.cover"
                class="hero-section-img"
                :alt="item.basic.title || 'hero'"
              />
            </div>
            <p class="hero-section-title">{{ item.basic.title }}</p>
          </div>
        </div>
      </div>
      <!-- <div
        v-if="showHeroList.length > 1"
        ref="heroPaginationEl"
        class="hero-section-pagination"
      ></div> -->
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Swiper from 'swiper';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import { safeDestroySwiper } from '@utiles/officialTopupNew/safeSwiper';

export default {
  name: 'HeroSection',
  data() {
    return {
      swiper: null
    };
  },
  computed: {
    ...mapState({
      heroSection: state => state.activity.heroSection,
      isLandscape: state => state.page.isLandscape
    }),
    showHeroList() {
      const list = [];
      (this.heroSection || []).forEach(item => {
        if (item?.basic?.cover) {
          list.push(item);
        }
      });
      return list;
    },
    /** 仅当条目数 ≥ 3 时使用 Swiper 轮播；否则居中静态展示 */
    needHeroSwiper() {
      return this.showHeroList.length >= 4;
    }
  },
  watch: {
    showHeroList: {
      deep: true,
      handler(newVal) {
        if (!newVal.length || this.isLandscape) return;
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    },
    isLandscape: {
      handler(val) {
        if (val) {
          this.destroyHeroSwiper();
        } else if (this.showHeroList.length) {
          this.$nextTick(() => {
            this.initSwiper();
          });
        }
      }
    }
  },
  mounted() {
    if (!this.isLandscape && this.showHeroList.length) {
      this.$nextTick(() => {
        this.initSwiper();
      });
    }
  },
  beforeDestroy() {
    this.swiper = safeDestroySwiper(this.swiper);
  },
  methods: {
    jumpLink(link) {
      if (!link) return;
      sdkOpenLink({ link: getGlobalGetGotoLink({ link }) });
    },
    initSwiper() {
      if (this.isLandscape || !this.showHeroList.length) {
        this.destroyHeroSwiper();
        return;
      }
      if (!this.needHeroSwiper) {
        this.destroyHeroSwiper();
        return;
      }
      const rootEl = this.$refs.heroSwiperEl;
      if (!rootEl) return;
      try {
        this.destroyHeroSwiper();
        // const multi = this.showHeroList.length > 1;
        // const paginationEl = multi ? this.$refs.heroPaginationEl : null;
        this.swiper = new Swiper(rootEl, {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 70,
          // pagination:
          //   multi && paginationEl
          //     ? {
          //         el: paginationEl,
          //         clickable: true
          //       }
          //     : false,
          effect: 'slide',
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          resizeObserver: true,
          watchOverflow: true,
          updateOnWindowResize: true,
          on: {
            resize: () => {
              if (this.swiper) {
                this.swiper.update();
              }
            }
          }
        });
      } catch (e) {
        console.error(e);
      }
    },
    destroyHeroSwiper() {
      this.swiper = safeDestroySwiper(this.swiper);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';

.hero-section {
  position: relative;
  width: 670px;
  margin: 0 auto;
  box-sizing: border-box;
  background-color: $backgroundColor;
}

.hero-section-centered {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items: flex-start;
  box-sizing: border-box;
  /* 与 Swiper spaceBetween 一致 */
  gap: 50px;
}

.hero-section-swiper {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

/* 放在 swiper 外侧，避免 overflow:hidden 裁切；与上图间距可改 margin-top */
.hero-section-pagination {
  margin-top: 20px;
  text-align: center;
  line-height: 1;
}

.hero-section-wrap {
  display: flex;
}

.hero-section-item {
  flex-shrink: 0;
  width: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.hero-section-img-wrap {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
}

.hero-section-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  display: block;
}

.hero-section-title {
  margin: 12px 0 0;
  width: 100%;
  max-width: 130px;
  font-size: 22px;
  line-height: 1.2;
  color: #333333;
  text-align: center;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>

<style lang="scss">
@import '@assets/scss/officialTopupNew/_dimen.scss';

.hero-section .hero-section-pagination {
  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background: #cccccc;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background: $themeColor;
  }
}
</style>
